<template>
  <article class="summary-card-block">
    <header
      v-if="block.title"
      class="summary-card-block__header"
    >
      <h3 class="summary-card-block__title">
        {{ block.title }}
      </h3>
      <p
        v-if="block.subtitle"
        class="summary-card-block__subtitle"
      >
        {{ block.subtitle }}
      </p>
    </header>

    <section
      v-if="block.description"
      class="summary-card-block__body"
    >
      {{ block.description }}
    </section>

    <ul
      v-if="block.metrics && block.metrics.length"
      class="summary-card-block__metrics"
    >
      <li
        v-for="metric in block.metrics"
        :key="metric.id || metric.label"
        class="summary-card-block__metric"
      >
        <span class="summary-card-block__metric-label">
          {{ metric.label }}
        </span>
        <span class="summary-card-block__metric-value">
          {{ metric.value }}
        </span>
      </li>
    </ul>

    <footer
      v-if="hasActions"
      class="summary-card-block__footer"
    >
      <ActionButtons
        :actions="block.actions"
        @action-click="onActionClick"
      />
    </footer>
  </article>
</template>

<script>
import ActionButtons from '@baserow/modules/copilot/components/generative/ActionButtons'

export default {
  name: 'SummaryCardBlock',
  components: {
    ActionButtons,
  },
  props: {
    /**
     * Summary card payload.
     *
     * Suggested shape:
     * - id: string
     * - title: string
     * - subtitle?: string
     * - description?: string
     * - metrics?: Array<{ id?: string, label: string, value: string | number }>
     * - actions?: GenerativeBlockAction[]
     */
    block: {
      type: Object,
      required: true,
    },
  },
  computed: {
    hasActions() {
      return Array.isArray(this.block.actions) && this.block.actions.length > 0
    },
  },
  methods: {
    onActionClick(action) {
      this.$emit('action-click', action, this.block)
    },
  },
}
</script>

<style scoped lang="scss">
.summary-card-block {
  border-radius: 6px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  padding: 10px 12px;
  background-color: #fff;
}

.summary-card-block__header {
  margin-bottom: 6px;
}

.summary-card-block__title {
  margin: 0;
  font-size: 13px;
  font-weight: 600;
}

.summary-card-block__subtitle {
  margin: 2px 0 0;
  font-size: 11px;
  color: #666;
}

.summary-card-block__body {
  font-size: 12px;
  margin-bottom: 6px;
}

.summary-card-block__metrics {
  list-style: none;
  padding: 0;
  margin: 0;
}

.summary-card-block__metric {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  padding-top: 2px;
}

.summary-card-block__metric-label {
  color: #666;
}

.summary-card-block__metric-value {
  font-weight: 600;
}

.summary-card-block__footer {
  margin-top: 8px;
}
</style>

